import { render, staticRenderFns } from "./ModifyDelivery.vue?vue&type=template&id=83c996ba&scoped=true&"
import script from "./ModifyDelivery.vue?vue&type=script&lang=ts&"
export * from "./ModifyDelivery.vue?vue&type=script&lang=ts&"
import style0 from "./ModifyDelivery.vue?vue&type=style&index=0&id=83c996ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c996ba",
  null
  
)

export default component.exports